import { useContext, useState } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import { useParams } from "react-router-dom";
import { createTripVideoSchema } from "../../validation/tripVideoSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { useValidation } from "../../hooks/useValidation";
import { useForm } from "react-hook-form";
import { tripVideoService } from "../../services/tripVideoService";
import { toast } from "../../services/toastService";
import BackButton from "../../components/common/BackButton";

const TripVideoForm = () => {
  const { t } = useContext(LocaleContext);
  const { tripId } = useParams();

  const [btnLoading, setBtnLoading] = useState(false);

  const initialForm = {
    tripVideos: [],
  };

  const handleClear = () => {
      reset(initialForm); // resets to initial values
    };
    //create validation schema
  
    const v = useValidation();
    const tripVideoSchema = createTripVideoSchema(v, t);

    const {
      register,
      handleSubmit,
      setValue,
      control,
      reset,
      formState: { errors },
      watch,
    } = useForm({
      defaultValues: initialForm,
      resolver: yupResolver(tripVideoSchema),
    });
const handleFileChange = (e) => {
  const files = Array.from(e.target.files || []);

  setValue("tripVideos", files, {
    shouldValidate: true,
    shouldDirty: true,
  });
};
 const onSubmit = async (values) => {
   try {
     setBtnLoading(true);
     const formData = new FormData();

     // 1. Append Files (must match the backend parameter name "files")
     values.tripVideos.forEach((file) => formData.append("files", file));

    const response = await tripVideoService.createAsync(tripId,formData);
     toast.success(t("recordAddedSuccessfully"));

     handleClear();
   } catch (error) {
     toast.error(t("anErrorOccurredPleaseTryAgainLater"));
     console.log(error);
   } finally {
     setBtnLoading(false);
   }
 };
  return (
    <section className="trip-video-form">
      <div className="default-heading">{t("tripVideos")}</div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="my-card">
          <div className="my-card-header d-flex justify-content-between align-items-center">
            <span><i className="fas fa-plus plus-icon"></i> {t("addNewVideo")}</span>
            <BackButton />
          </div>
          <div className="my-card mt-3">
            <div className="my-card-header text-primary">{t("video")}</div>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <input
                    id="trip-video"
                    {...register("tripVideos")}
                    onChange={handleFileChange}
                    type="file"
                    accept="video/*"
                    className="d-none"
                  />
                  <label htmlFor="trip-video" className="my-file-upload">
                    <div>
                      {t("selectVideo")}
                      {" "}
                      <span className="text-primary">
                        {watch("tripVideos")?.length > 0
                          ? `(${watch("tripVideos")?.length})`
                          : ""}
                      </span>{" "}
                    </div>
                    <i class="fas fa-video"></i>
                  </label>
                  {errors.tripVideos && (
                    <p className="text-danger">{errors.tripVideos.message}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="mt-3 gap-2 d-flex justify-content-end">
            <button type="submit" className="btn-default">
              {t("save")}
            </button>
            <button type="button" className="btn-secondary">
              {t("cancel")}
            </button>
          </div>
        </div>
      </form>
    </section>
  );
};

export default TripVideoForm;
